import { ComponentType } from 'react';
import { connectMediaStore, useMMSelector, useMMDispatchActions } from './withOwnReduxStore';
import { setCurrentFolderId, unsetCurrentFolderId } from '../actions';
import { getCurrentGallection, getCurrentFolderId } from '../selectors';
import { PapiGallection } from '@wix/da-papi-types';

export type WithCurrentGallectionProps = {
  currentGallection: PapiGallection | undefined;
  currentFolderId?: number;
  setCurrentFolderId: (folderId: number) => any;
  unsetCurrentFolderId: () => any;
};

type StateProps = Pick<WithCurrentGallectionProps, 'currentGallection' | 'currentFolderId'>;
type DispatchProps = Pick<
  WithCurrentGallectionProps,
  'setCurrentFolderId' | 'unsetCurrentFolderId'
>;
type OwnProps = Omit<WithCurrentGallectionProps, keyof (StateProps & DispatchProps)>;

export const useCurrentGallection = (): WithCurrentGallectionProps => ({
  ...useMMSelector(state => ({
    currentFolderId: getCurrentFolderId(state),
    currentGallection: getCurrentGallection(state),
  })),
  ...useMMDispatchActions({
    setCurrentFolderId,
    unsetCurrentFolderId,
  }),
});

export default <TProps>(
  component: ComponentType<TProps & WithCurrentGallectionProps>
): ComponentType<TProps> =>
  connectMediaStore<StateProps, DispatchProps, OwnProps>(
    state => ({
      currentFolderId: getCurrentFolderId(state),
      currentGallection: getCurrentGallection(state),
    }),
    {
      setCurrentFolderId,
      unsetCurrentFolderId,
    }
  )(component as ComponentType<any>); // redux typings are a bit dumb with generics
